import React, { MouseEventHandler, CSSProperties, ReactNode } from 'react';
import classnames from 'classnames';
import { Translate } from '../translate';
import { useTranslation } from 'react-i18next';

interface ButtonProps {
	btnType?: 'default' | 'primary' | 'warning' | 'danger' | 'info',
	loading?: boolean,
	disabled?: boolean,
	type?: 'submit' | 'button' | 'reset',
	className?: string,
	onClick?: MouseEventHandler<any>;
	abbr?: string;
	title?: string;
	style?: CSSProperties;
	dataTestId?: string;
	children?: ReactNode;
}
const Button: React.FC<ButtonProps> = (props) => {
	const { t } = useTranslation();
	const onClick: MouseEventHandler<any> = (e) => !props.loading && props.onClick && props.onClick(e);
	const button = (
		<button
			data-testid={props.dataTestId || null}
			title={t(props.abbr || '')}
			type={props.type || 'button'}
			className={classnames('btn', `btn-${props.btnType || 'default'}`, 'ignore-text-capitalize', props.className)}
			disabled={props.loading || props.disabled}
			style={props.style || {}}
			onClick={!props.disabled && !props.loading ? onClick : () => { }}
		>
			{
				props.loading ?
					<i className="fa fa-spin fa-spinner" />
					:
					typeof props.children === 'string' ? <Translate text={props.children} /> : props.children
			}
		</button>
	);
	return (
		props.abbr ? (
			<abbr title={t(props.abbr || '')} className='custom-abbr'>
				{button}
			</abbr>
		) : button
	)
}

export default Button;
